module.exports = __webpack_public_path__ + "img/kenzo-homme-logo.2e0bee9c.svg";